import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { State } from 'app/common/types';
import { currentAppEntity } from 'app/developer-v3/selectors';
import { createPartnerUserInteractionEventTracker } from 'app/developer-v3/teams/team-partner-sharing/createInteractionTracker';

import Credentials from './Credentials';

function mapStateToProps(state: State) {
  const trackInteraction = createPartnerUserInteractionEventTracker(state);
  const appEntity = currentAppEntity(state);
  const slug = CliApp.selectors.slug(appEntity);

  return { trackInteraction, slug };
}

function mapDispatchToProps(dispatch) {
  return {
    onLoad() {
      dispatch(CliApp.actions.loadCollectionWithParams({ full: true }));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(Credentials));
